import styled, { css } from 'styled-components';

import Button from '../Button';
import Icon from 'Elements/Icon';

export const Container = styled(Button)`
    ${({ theme }) => css`
        & {
            font-size: 1.125rem;
            font-weight: 400;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            color: ${theme.colors.secondary.tints[6].hex};

            &:hover {
                background-color: ${theme.colors.secondary.tints[0].hex};

                ${StyledIcon} {
                    transform: rotate(-180deg);
                }
            }
        }
    `}
`;

export const StyledIcon = styled(Icon)`
    ${({ theme }) => css`
        stroke-width: 0.01rem;
        width: 1.75rem;
        height: 1.75rem;
        margin-left: 0.25rem;
        fill: ${theme.colors.secondary.tints[6].hex};
        transition: 0.25s ease-in-out;
    `}
`;
